module.exports = __webpack_public_path__ + "static/media/False Consensus.0a25c365.jpg";